// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import sessionSpeakerEntity from './entities/session-speaker.json';
import sessionSpeakerMenu from '../pages/session-speaker/menu.json';
import sessionSpeakerFullForm from '../pages/session-speaker/forms/full.json';
import sessionSpeakerContextForm from '../pages/session-speaker/forms/context.json';
import sessionSpeakerMiniForm from '../pages/session-speaker/forms/mini.json';
import sessionSpeakerLookupForm from '../pages/session-speaker/forms/lookup.json';
import sessionSpeakerTableView from '../pages/session-speaker/views/table.json';
import sessionSpeakerCardsView from '../pages/session-speaker/views/cards.json';
import sessionSpeakerCalendarView from '../pages/session-speaker/views/calendar.json';
import sessionSpeakerDashboardView from '../pages/session-speaker/views/dashboard.json';

/** Тип запису «Промовець» зі сторінками пакета: меню, форми та подання з pages/session-speaker/. */
export const sessionSpeakerDefinition: IRecordTypeDefinition = {
  ...sessionSpeakerEntity,
  views: assembleViewSet({
      table: sessionSpeakerTableView,
      cards: sessionSpeakerCardsView,
      calendar: sessionSpeakerCalendarView,
      dashboard: sessionSpeakerDashboardView,
  }),
  form: sessionSpeakerFullForm,
  forms: { full: sessionSpeakerFullForm, context: sessionSpeakerContextForm, mini: sessionSpeakerMiniForm, lookup: sessionSpeakerLookupForm },
  menu: sessionSpeakerMenu,
} as IRecordTypeDefinition;
